import ctaBackgroundUrl from "@/assets/images/cta-final-fundo.jpg"
import { cn } from "@/shared/lib/cn"
import { scrollToAnchor } from "@/shared/lib/navigation"
import { openWhatsApp } from "@/shared/lib/whatsapp"
import { useInView } from "@/shared/hooks/useInView"
import { BrandSymbol } from "@/shared/ui/BrandSymbol"
import { Button } from "@/shared/ui/Button"
import { ArrowRight } from "@/shared/ui/icons"

/** Classes de entrada por scroll. O delay varia por elemento, a transicao nao. */
function reveal(inView: boolean, delay: string, distance = "translate-y-6") {
  return cn("transition-all duration-700", delay, inView ? "opacity-100 translate-y-0" : `opacity-0 ${distance}`)
}

export function CtaFinalSection() {
  const { ref, inView } = useInView()

  return (
    <section ref={ref} className="relative overflow-hidden bg-verde-profundo py-24 lg:py-36">
      <div className="absolute inset-0" aria-hidden="true">
        <img
          src={ctaBackgroundUrl}
          alt=""
          loading="lazy"
          decoding="async"
          className="w-full h-full object-cover object-center"
          style={{ filter: "saturate(0.5) brightness(0.25)" }}
        />
        <div
          className="absolute inset-0"
          style={{
            background:
              "linear-gradient(135deg, rgba(46,55,36,0.97) 0%, rgba(46,55,36,0.80) 50%, rgba(46,55,36,0.92) 100%)",
          }}
        />
        <div
          className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] rounded-full"
          style={{ background: "radial-gradient(ellipse, rgba(201,150,59,0.12) 0%, transparent 65%)" }}
        />
        <div
          className="absolute bottom-0 left-0 right-0 h-[3px]"
          style={{
            background:
              "linear-gradient(90deg, transparent 0%, #C9963B 30%, #E8C97A 50%, #C9963B 70%, transparent 100%)",
          }}
        />
      </div>

      <BrandSymbol className="absolute right-[-60px] top-1/2 -translate-y-1/2 w-[240px] sm:w-[380px] lg:w-[520px] sm:h-[380px] lg:h-[520px] text-white opacity-[0.05] pointer-events-none" />

      <div className="relative max-w-[1280px] mx-auto px-6 flex flex-col items-center text-center gap-8">
        <span
          className={cn(
            "inline-flex items-center gap-2 px-5 py-2 rounded-full bg-dourado/15 border border-dourado/25 text-dourado-claro text-xs font-semibold tracking-widest uppercase",
            reveal(inView, ""),
          )}
        >
          <span className="w-1.5 h-1.5 rounded-full bg-dourado inline-block animate-pulse" />
          Comece agora
        </span>

        <h2
          className={cn(
            "text-3xl sm:text-4xl md:text-5xl lg:text-[60px] font-semibold text-off-white leading-[1.06] tracking-[-0.025em] max-w-3xl",
            reveal(inView, "delay-100", "translate-y-8"),
          )}
        >
          Comece hoje a cuidar do <span className="shimmer-gold">futuro do seu pet</span>
        </h2>

        <p
          className={cn(
            "text-lg text-off-white/60 leading-relaxed max-w-xl",
            reveal(inView, "delay-200"),
          )}
        >
          Conheça as opções da DIMPET e encontre o plano adequado para acompanhar a saúde do seu melhor amigo.
        </p>

        <div className={cn("flex flex-wrap justify-center gap-4", reveal(inView, "delay-300"))}>
          <Button
            variant="gold"
            size="lg"
            onClick={() => openWhatsApp()}
            className="shadow-lg shadow-dourado/30 hover:shadow-xl hover:shadow-dourado/40 hover:-translate-y-0.5"
            icon={<ArrowRight />}
          >
            Contratar agora
          </Button>
          <Button
            variant="secondary"
            size="lg"
            onClick={() => scrollToAnchor("#planos")}
            className="border-off-white/20 text-off-white hover:bg-off-white/10 hover:text-off-white hover:border-off-white/35"
          >
            Conhecer os planos
          </Button>
        </div>

        <p
          className={cn(
            "text-xs text-off-white/25 max-w-md leading-relaxed transition-all duration-700 delay-[400ms]",
            inView ? "opacity-100" : "opacity-0",
          )}
        >
          Consulte disponibilidade, condições, carências, coberturas e rede credenciada.
        </p>
      </div>
    </section>
  )
}
